//đẩy lên server : 
export const BaseGatewayImage = 'https://api.quanlykpic9.cntt108.vn';
export const BaseGateway = 'https://api.quanlykpic9.cntt108.vn/api/v1';

export const BaseGatewayAuthApi = 'https://api.authservice.cntt108.vn/api/v1';
export const BaseGatewayAuth = 'https://api.authservice.cntt108.vn';
export const BaseGatewayAuthImage = 'https://api.authservice.cntt108.vn';

export const BaseGatewayCommon = 'https://api.corehub.cntt108.vn/api/v1';

//--------------------------------


//local
// Danh mục công việc thường niên
//----------------------------------------------

// export const BaseGatewayImage = 'https://localhost:5001';
// export const BaseGateway = 'https://localhost:5001/api/v1';

// export const BaseGatewayCommon = 'https://localhost:4999/api/v1';

// export const BaseGatewayAuthApi = 'https://localhost:5003/api/v1';
// export const BaseGatewayAuth = 'https://localhost:5003';
// export const BaseGatewayAuthImage = 'https://localhost:5003';

const BaseGatewayFromMainServer = 'http://108.108.108.52:10808';

export const BaseGatewayClient = 'http://interbgc.com.vn'

const BaseGatewayCrawler = 'http://crawlerapi.xecong.info';
// api chung lấy nguộn 
export const AUTH_API = {
    LOGIN_API: `${BaseGatewayAuth}/connect/token`,
    REFRESHTOKEN_API: `${BaseGatewayAuth}/connect/token`,
    FORGOT_PASSWORD: `${BaseGatewayAuth}/Auth/ForgotPassword`,
    RESET_PASSWORD: `${BaseGatewayAuth}/Auth/ResetPassword`
};

export const ACCOUNT_API = {
    GET_PAGING_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetAllPaging`,
    ADD_ACCOUNT: `${BaseGatewayAuthApi}/Account/Create`,
    EDIT_ACCOUNT: `${BaseGatewayAuthApi}/Account/Update`,
    DELETE_ACCOUNT: `${BaseGatewayAuthApi}/Account/DeleteItem`,
    GET_BY_ID_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetItem`,
    COUNT_ALL_ACCOUNT_API: `${BaseGatewayAuthApi}/Account/CountAllAccount`,
    CHANGE_PASSWORD_API: `${BaseGatewayAuthApi}/Account/ChangePassword`,
    GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG: `${BaseGatewayCommon}/AccountInfo/SelectAccountInfoByAccountId`,
};

export const ACCOUNTAUTHINFO_API = {
    GET_PAGING: `${BaseGatewayAuthApi}/AccountAuthInfo/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/AccountAuthInfo/GetItem`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/AccountAuthInfo/UpdateItem`,
    CREATE: `${BaseGatewayAuthApi}/AccountAuthInfo/Create`
};

export const OPENIDDICTAPPLICATION_API = {
    GET_PAGING: `${BaseGatewayAuthApi}/OpeniddictApplication/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/GetItem`,
    ADD_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/DeleteItem`
};

export const FILE_MANAGER_API = {
    UPLOAD: `${BaseGatewayAuthApi}/FileManager/Upload`,
    GET_PAGING: `${BaseGatewayAuthApi}/FileManager/GetAllByPaging`,
    GET_DIR_PATH: `${BaseGatewayAuthApi}/FileManager/GetDirectoryPath`,
    DELETE: `${BaseGatewayAuthApi}/FileManager`
};

export const PROJECT_FILE_MANAGER_API = {
    UPLOAD: `${BaseGateway}/FileManager/Upload`,
    GET_PAGING: `${BaseGateway}/FileManager/GetAllByPaging`,
    GET_DIR_PATH: `${BaseGateway}/FileManager/GetDirectoryPath`,
    DELETE: `${BaseGateway}/FileManager`
};

export const EMAILCONFIG_API = {
    GET_PAGING_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetAllByPaging`,
    GET_ITEM_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetItem`,
    ADD_EMAILCONFIG: `${BaseGateway}/EmailConfig/CreateEmailConfig`,
    UPDATE_EMAILCONFIG: `${BaseGateway}/EmailConfig/UpdateItem`,
    DELETE_EMAILCONFIG: `${BaseGateway}/EmailConfig/DeleteItem`
};

export const LOGIN_HISTORY_API = {
    GET_PAGING_LOGIN: `${BaseGatewayAuth}/LoginHistory/GetAllPaging`,
    STATISTIC_LOGIN: `${BaseGatewayAuth}/LoginHistory/GetStatisticsLoginByAccount`,
    STATISTIC_COUNT_LOGIN_BY_DATE: `${BaseGatewayAuth}/LoginHistory/CountAllByDate`
};

export const LOG_API = {
    GET_PAGING_LOG: `${BaseGateway}/Log/GetAllByPaging`,
    DELETE_LOG: `${BaseGateway}/Log/DeleteByDate`,
    COUNT_LOG_BY_DATE: `${BaseGateway}/Log/CountLogsByDate`,
};

export const APIROLEMAPPING_API = {
    GET_PAGING: `${BaseGateway}/ApiRoleMapping/GetAllByPaging`,
    GET_PAGING_NOT_MENU: `${BaseGateway}/ApiRoleMapping/GetAllByPagingNotMenu`,
    GET_ITEM: `${BaseGateway}/ApiRoleMapping/GetItem`,
    ADD_ITEM: `${BaseGateway}/ApiRoleMapping/Create`,
    UPDATE_ITEM: `${BaseGateway}/ApiRoleMapping/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ApiRoleMapping/DeleteItem`,
    BULK_ASSIGN_ROLES: `${BaseGateway}/ApiRoleMapping/BulkAssignRoles`
};

export const AUTH_APIROLEMAPPING_API = {
    GET_PAGING: `${BaseGatewayAuthApi}/ApiRoleMapping/GetAllByPaging`,
    GET_PAGING_NOT_MENU: `${BaseGatewayAuthApi}/ApiRoleMapping/GetAllByPagingNotMenu`,
    GET_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/GetItem`,
    ADD_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/DeleteItem`,
    BULK_ASSIGN_ROLES: `${BaseGatewayAuthApi}/ApiRoleMapping/BulkAssignRoles`
};

// export const APIROLEMAPPING_API = {
//     GET_PAGING: `${BaseGatewayAuthApi}/ApiRoleMapping/GetAllByPaging`,
//     GET_PAGING_NOT_MENU: `${BaseGatewayAuthApi}/ApiRoleMapping/GetAllByPagingNotMenu`,
//     GET_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/GetItem`,
//     ADD_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/Create`,
//     UPDATE_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/UpdateItem`,
//     DELETE_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/DeleteItem`,
//     BULK_ASSIGN_ROLES: `${BaseGatewayAuthApi}/ApiRoleMapping/BulkAssignRoles`
// };

export const ROLE_API = {
    GET_ALL: `${BaseGatewayAuthApi}/Role/GetAll`,
    GET_PAGING: `${BaseGatewayAuthApi}/Role/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/Role/GetItem`,
    ADD_ITEM: `${BaseGatewayAuthApi}/Role/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/Role/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/Role/DeleteItem`,
    UPDATE_TREE: `${BaseGatewayAuthApi}/Role/UpdateTree`
};

export const MENU_API = {
    GET_PAGING: `${BaseGateway}/MenuItem/GetAllByPaging`,
    GET_MENU: `${BaseGateway}/MenuItem/GetMenu`,
    GET_ITEM: `${BaseGateway}/MenuItem/GetItem`,
    ADD_ITEM: `${BaseGateway}/MenuItem/Create`,
    UPDATE_ITEM: `${BaseGateway}/MenuItem/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/MenuItem/DeleteItem`,
    UPDATE_TREE: `${BaseGateway}/MenuItem/UpdateTree`
};

export const KYSO_API = {
    KYSO: `${BaseGateway}/KySo/AuthorizeKySo`,
};

export const PROJECT_API = {
    GET_PAGING: `${BaseGateway}/Project/GetAllPaging`,
    GET_ITEM: `${BaseGateway}/Project/GetItem`,
    ADD: `${BaseGateway}/Project/Create`,
    UPDATE: `${BaseGateway}/Project/Update`,
    DELETE: `${BaseGateway}/Project/Delete`,
    CHANGE_STATUS: `${BaseGateway}/Project/ChangeStatus`,
};

export const ASSIGNED_JOB_API = {
    GET_PAGING: `${BaseGateway}/AssignedJob/GetAllPaging`,
    GET_ITEM: `${BaseGateway}/AssignedJob/GetItem`,
    ADD: `${BaseGateway}/AssignedJob/Create`,
    UPDATE: `${BaseGateway}/AssignedJob/Update`,
    DELETE: `${BaseGateway}/AssignedJob/Delete`,
    CHANGE_STATUS: `${BaseGateway}/AssignedJob/ChangeStatus`,
};

export const PERSONALTASK_API = {
    GET_MY_ASSIGNMENTS: `${BaseGateway}/PersonalTask/GetMyAssignments`,
    UPDATE_ASSIGNMENT_STATUS: `${BaseGateway}/PersonalTask/UpdateAssignmentStatus`,
    ADD_EVIDENCE: `${BaseGateway}/PersonalTask/AddEvidenceFile`,
    GET_EVIDENCE: `${BaseGateway}/PersonalTask/GetEvidenceFiles`,
    DELETE_EVIDENCE: `${BaseGateway}/PersonalTask/DeleteEvidenceFile`
};

export const JOBGROUP_API = {
    GET_PAGING: `${BaseGateway}/JobGroup/GetAllPaging`,
    GET_ALL: `${BaseGateway}/JobGroup/GetAll`,
    GET_ITEM: `${BaseGateway}/JobGroup/GetItem`,
    ADD: `${BaseGateway}/JobGroup/Create`,
    UPDATE: `${BaseGateway}/JobGroup/Update`,
    DELETE: `${BaseGateway}/JobGroup/Delete`,
};

export const ANNUAL_JOB_API = {
    GET_PAGING: `${BaseGateway}/AnnualJob/GetAllPaging`,
    GET_ALL_ACTIVE: `${BaseGateway}/AnnualJob/GetAllActive`,
    GET_ITEM: `${BaseGateway}/AnnualJob/GetById`,
    ADD: `${BaseGateway}/AnnualJob/Create`,
    UPDATE: `${BaseGateway}/AnnualJob/Update`,
    DELETE: `${BaseGateway}/AnnualJob/Delete`,
};

export const ANNUAL_JOB_REGISTRATION_API = {
    GET_MY_REGISTRATIONS: `${BaseGateway}/AnnualJobRegistration/GetMyRegistrations`,
    GET_BY_ID: `${BaseGateway}/AnnualJobRegistration/GetById`,
    CREATE: `${BaseGateway}/AnnualJobRegistration/Create`,
    UPDATE: `${BaseGateway}/AnnualJobRegistration/Update`,
    DELETE: `${BaseGateway}/AnnualJobRegistration/Delete`,
    SUBMIT: `${BaseGateway}/AnnualJobRegistration/SubmitForApproval`,
    RECALL: `${BaseGateway}/AnnualJobRegistration/RecallSubmission`,
};

export const ANNUAL_JOB_APPROVAL_API = {
    GET_ALL_PENDING: `${BaseGateway}/AnnualJobApproval/GetAllPendingRegistrations`,
    GET_ALL_APPROVED: `${BaseGateway}/AnnualJobApproval/GetAllApprovedRegistrations`,
    GET_BY_ID: `${BaseGateway}/AnnualJobApproval/GetById`,
    APPROVE: `${BaseGateway}/AnnualJobApproval/Approve`,
    REJECT: `${BaseGateway}/AnnualJobApproval/Reject`,
    CANCEL_APPROVAL: `${BaseGateway}/AnnualJobApproval/CancelApproval`,
    UPDATE_END_DATE: `${BaseGateway}/AnnualJobApproval/AdminUpdateRegistrationEndDate`,
    UPDATE_DETAIL_END_DATE: `${BaseGateway}/AnnualJobApproval/AdminUpdateDetailEndDate`,
    ADMIN_UPDATE: `${BaseGateway}/AnnualJobApproval/AdminUpdate`,
};

export const ANNUAL_JOB_KANBAN_API = {
    GET_KANBAN_BOARD: `${BaseGateway}/AnnualJobKanban/GetMyKanbanBoard`,
    UPDATE_STATUS: `${BaseGateway}/AnnualJobKanban/UpdateStatus`,
    ADD_PROGRESS: `${BaseGateway}/AnnualJobKanban/AddProgress`,
    ADD_EVIDENCE_FILE: `${BaseGateway}/AnnualJobKanban/AddEvidenceFile`,
    DELETE_EVIDENCE_FILE: `${BaseGateway}/AnnualJobKanban/DeleteEvidenceFile`,
    DELETE_PROGRESS: `${BaseGateway}/AnnualJobKanban/DeleteProgress`,
    DELETE_TASK_CARD: `${BaseGateway}/AnnualJobKanban/DeleteTaskCard`
};


export const MEMBER_TRACKING_API = {
    GET_MEMBER_TRACKING: `${BaseGateway}/MemberTracking/GetMemberTrackingData`,
    GET_ALL_MEMBERS_TRACKING: `${BaseGateway}/MemberTracking/GetAllMembersTracking`,
};

export const WORK_RESULT_API = {
    GET_ALL_PAGING: `${BaseGateway}/WorkResult/GetAllPaging`,
    GET_EXPORT_DATA: `${BaseGateway}/WorkResult/GetExportData`,
    SAVE_EVALUATION: `${BaseGateway}/WorkResult/SaveEvaluation`,
    RETURN_TASK: `${BaseGateway}/WorkResult/ReturnTask`,
    GET_HISTORY: `${BaseGateway}/WorkResult/GetHistory`,
};

export const POSITION_API = {
    GET_PAGING: `${BaseGateway}/Position/GetAllPaging`,
    GET_ALL_ACTIVE: `${BaseGateway}/Position/GetAllActive`,
    GET_ITEM: `${BaseGateway}/Position/GetItem`,
    ADD: `${BaseGateway}/Position/Create`,
    UPDATE: `${BaseGateway}/Position/Update`,
    DELETE: `${BaseGateway}/Position/DeleteItem`
};

export const ACCOUNT_POSITION_API = {
    UPSERT: `${BaseGateway}/AccountPosition/Upsert`,
    GET_BY_ACCOUNT_ID: `${BaseGateway}/AccountPosition/GetByAccountId`,
    DELETE_BY_ACCOUNT_ID: `${BaseGateway}/AccountPosition/DeleteByAccountId`,
    GET_BY_ACCOUNT_IDS: `${BaseGateway}/AccountPosition/GetByAccountIds`,
};

export const ACCOUNT_EMAIL_API = {
    GET_BY_ACCOUNT_ID: `${BaseGateway}/AccountEmail/GetByAccountId`,
    GET_BY_ACCOUNT_IDS: `${BaseGateway}/AccountEmail/GetByAccountIds`,
    GET_ALL: `${BaseGateway}/AccountEmail/GetAll`,
    UPSERT: `${BaseGateway}/AccountEmail/Upsert`,
    BULK_SYNC: `${BaseGateway}/AccountEmail/BulkSync`,
};

